import { createContext, useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios'

export const AppContext = createContext();

export const AppContextProvider = (props) => {

    axios.defaults.withCredentials = true;

    const backendUrl = process.env.REACT_APP_BACKEND_URL
    const [isLoggedIn, setIsLoggedIn] = useState(null);
    const [userData, setUserData] = useState(null);

    // Get User Data
    const getUserData = useCallback(async () => {
        try {
            const { data } = await axios.get(backendUrl + '/api/user/data')
            if (data.success) setUserData(data.userData);
        } catch (error) {
            toast.error(error.message);
        }
    }, [backendUrl]);

    // Is User Authenticated
    const getAuthState = useCallback(async () => {
        try {
            const { data } = await axios.get(backendUrl + '/api/auth/is-auth')
            if (data.success) {
                setIsLoggedIn(true);
                getUserData();
            } else {
                setIsLoggedIn(false);
                setUserData(false);
            }
        } catch (error) {
            toast.error(error.message);
        }
    }, [backendUrl, getUserData]);

    useEffect(() => {
        getAuthState();
    }, [getAuthState]);

    const value = {
        backendUrl,
        isLoggedIn,
        setIsLoggedIn,
        userData,
        setUserData,
        getUserData
    }

    return (
        <AppContext.Provider value={value}>
            {props.children}
        </AppContext.Provider>
    )
}